import React, { Component } from 'react';
import { Grid, GridCell } from 'rmwc/Grid';
import { connect } from 'react-redux';
import { Typography } from 'rmwc/Typography';
import { Link } from 'react-router-dom'
import { Card } from 'rmwc/Card';
import { List, ListItem, ListItemText, ListItemGraphic} from 'rmwc/List';

class RegistrationHome extends Component{
    constructor(props) {
        super(props)
        this.state = {
            data:{
                pageStatus: ''
            }
        }
    }

    componentDidMount() {
        
    }

    render(){
        let mainPageContent
        
            mainPageContent = (
                <Grid>
                    <GridCell span = "12">
                        <Card style={{padding: '0px'}}>
                            <Grid className="opportunity-list-item">
                                <GridCell span = "11">
                                    <Typography use="headline5">Register For</Typography>
                                </GridCell>
                            </Grid>
                        </Card>
                    </GridCell>
                    <GridCell span = "12">
                    <Typography use="subtitle2"></Typography>
                    <br/>
                    <List>
                        <ListItem>
                            <ListItemGraphic>bookmarks</ListItemGraphic>
                            <ListItemText><Link to="/portal/app/tpo_registration_details">CENTA Teaching Professionals' Olympiad (TPO) 2020</Link><br /><Typography use="caption">India's national competition for teachers</Typography></ListItemText>
                        </ListItem>
                        <br />
                        <ListItem>
                            <ListItemGraphic>how_to_vote</ListItemGraphic>
                            <ListItemText><Link to="/portal/app/tq_registration">CENTA Teaching Quotient (TQ)</Link><br /><Typography use="caption">Competency score for teacher recruitment</Typography></ListItemText>
                        </ListItem>
                        <br />
                        <ListItem>
                            <ListItemGraphic>map</ListItemGraphic>
                            <ListItemText><Link to="/portal/app/mc_registration">CENTA Micro-Credentials</Link><br /><Typography use="caption">Certifications of excellence in teaching - focused on specific sets of competencies</Typography></ListItemText>
                        </ListItem>
                        <br />
                        <ListItem>
                            <ListItemGraphic>assignment</ListItemGraphic>
                            <ListItemText><Link to="/portal/app/fc_registration">CENTA Certification</Link><br /><Typography use="caption">Certification of excellence in teaching - combining all Micro-Credentials</Typography></ListItemText>
                        </ListItem>
                        <br />
                        
                        
                        
                    </List>
                    </GridCell>
                </Grid>
            )
        
       
        return(
            <div>
                {mainPageContent}
            </div>
        )
    }
}

function mapStateToProps({user, admin}) {
  return {
    user,
    admin
  }
}

function mapDispatchToProps() {
  return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(RegistrationHome);


// WEBPACK FOOTER //
// ./src/views/RegistrationHome.jsx